import React from "react";
import { useParams } from "react-router-dom";

import Panel from "components/Panel";
import PageContent from "components/PageContent";
import Form from "components/Form";
import FormSubmit from "components/FormSubmit";
import Loading from "components/Loading";
import RoleForm from "components/RoleForm";

import { useRoleNewQuery } from "./gql/Query.generated";
import { useRoutes } from "utils/routes";

const RoleNew: React.FunctionComponent = () => {
  const { slug: organizationSlug } = useParams();
  const { organizationRoles } = useRoutes();
  const { data, loading, error } = useRoleNewQuery({
    variables: { organizationSlug },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }
  const { name } = data.getOrganizationDetails;
  return (
    <PageContent
      title={`Organization "${name}"`}
      pageCategory="organization-roles"
      pageName="new"
    >
      <Panel title="Create Role">
        <Form
          action={organizationRoles(organizationSlug)}
          className="!max-w-6xl"
        >
          <RoleForm organizationSlug={organizationSlug} />
          <FormSubmit title="Create Role" />
        </Form>
      </Panel>
    </PageContent>
  );
};

export default RoleNew;
